<script>
  import { mapMutations, mapGetters } from 'vuex'
  import Helpers from '~plugins/Helpers'
  import { FormatPrice } from './CustomOptionsMixins'

export default {
  computed: {
    ...mapGetters({
      addToCartButtonState: 'GET_ADD_TO_CART_BUTTON_STATE',
      $t: 'GET_TRAD',
      currentProduct: 'GET_CURRENT_PRODUCT',
      productInformations: 'GET_PRODUCT_INFORMATIONS'
    }),
      dateTimeForPlansPromo() {
          let startDate
          let endDate
          if (this.currentProduct.plan.promo_date_start_1 || this.currentProduct.plan.promo_date_end_1) {
              startDate = this.currentProduct.plan.promo_date_start_1;
              endDate = this.currentProduct.plan.promo_date_end_1;
          } else {
              return false;
          }

          let timezone = this.currentProduct.plan.timezone_config;
          var now = new Date();
          var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

          return startDate <= currentTime && endDate >= currentTime
      },
    monthlyPrice () {
      let monthly_price
        if (this.currentProduct.plan.monthly_promo_price && this.currentProduct.plan.monthly_promo_price.length > 0  && this.dateTimeForPlansPromo) {
            monthly_price = this.currentProduct.plan.monthly_promo_price && this.currentProduct.plan.monthly_promo_price.length > 0 && this.dateTimeForPlansPromo ? parseFloat(this.currentProduct.plan.monthly_promo_price) : 0
        } else {
            monthly_price = this.currentProduct.plan.monthly_price ? parseFloat(this.currentProduct.plan.monthly_price) : 0
        }

      let instalment_amount = this.currentProduct.plan.instalment_amount ? parseFloat(this.currentProduct.plan.instalment_amount) : 0

      let price = instalment_amount ? monthly_price + instalment_amount : monthly_price

      if (price === '') price = 0

        let queryParam = new URLSearchParams(window.location.search);
        if (this.dateTimeForPlansPromo && (+this.currentProduct.plan.monthly_promo_price <= +this.currentProduct.plan.subscription_convergent_discount)) {
            price = parseFloat(price);
        } else if(+queryParam.get('livebox_prices') && this.currentProduct.plan.subscription_convergent_discount) {
            price = parseFloat(price - +this.currentProduct.plan.subscription_convergent_discount);
        } else if (queryParam.get('livebox_prices') == 0) {
            localStorage.setItem('is_enable_livebox_for_plan', 0);
            document.cookie = "is_enable_livebox_for_plan=0; path=/";
        } else if (localStorage.getItem('is_enable_livebox_for_plan') == '1' && this.currentProduct.plan.subscription_convergent_discount) {
            price = parseFloat(price - +this.currentProduct.plan.subscription_convergent_discount);
        }

      return this.formatPrice(price)
    },
    packageWithPhone () {
      return Helpers.getParamValue('fromPlan') ? true : false
    },
    popOverBodyContent () {
      let instalment_duration = this.currentProduct.plan.instalment_duration
      let instalment_amount = this.currentProduct.plan.instalment_amount
      let device_plan_engagement_duration = this.currentProduct.plan.device_plan_engagement_duration
      const currency = this.currentProduct.currency
      const locale = this.productInformations.locale
        let liveboxDiscountPrice = this.currentProduct.plan.subscription_convergent_discount
      let monthly_promo_price = this.currentProduct.plan.monthly_promo_price
      let promo_price_text = this.currentProduct.plan.plan_promo_subscription_duration
      let monthly_price_formatted
        let price_month_formatted = this.currentProduct.plan.monthly_price_formatted.replace(/\s/g, '')

        if (monthly_promo_price && monthly_promo_price.length > 0 && this.dateTimeForPlansPromo) {
            monthly_price_formatted = this.formatPrice(Math.max(0, monthly_promo_price))
        } else {
            monthly_price_formatted = this.currentProduct.plan.monthly_price_formatted.replace(/\s/g, '')
        }

        const liveboxAdvantageSpan = this.showLiveboxAdvantage() ? `<span class="text-nowrap t-text--small u-white u-marg-t-xxs">${this.$t('Livebox advantage')}</span>` : '';
        const liveboxDiscountSpan = this.showLiveboxAdvantage() ? `<span class="t-text--small u-orange u-marg-t-xxs">-${this.formatPrice(liveboxDiscountPrice)}${this.$t('/month')}</span>` : '';

        if (instalment_duration && instalment_amount) {
          if (instalment_duration == 0 && instalment_amount == 0 && device_plan_engagement_duration == 0) {
              return `
          <div class="u-flex u-flex-justify-between">
            <div class="u-flex u-flex-column">
              <span class="u-white">${this.currentProduct.plan.name}</span>
              ${liveboxAdvantageSpan}
              <span class="u-white u-marg-t-xxs">${this.$t('Instalment')}</span>
            </div>
             <div class="u-flex u-flex-column u-marg-l-md u-right">
               <span class="u-orange">${monthly_price_formatted}/${this.$t('month')}</span>
               ${liveboxDiscountSpan}
              <span class="u-orange u-marg-t-xxs">-</span>
              <span class="u-orange">-</span>
                       </div>
          </div>
        `
          } else {

        let instalmentAmount = locale === 'en' ? `${this.$t('%1/month').replace('%1', `${currency}${instalment_amount}`)}</br>${this.$t('for %2 month').replace('%2', instalment_duration)}` : `${this.$t('%1/month').replace('%1', `${instalment_amount}${currency}`)}</br>${this.$t('for %2 month').replace('%2', instalment_duration)}`
        let span_promo_space
      let span_promo
     let text_with_discount_for_promo
              if (promo_price_text !== '1') {
                  text_with_discount_for_promo = `${this.$t('for %1 months, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', price_month_formatted)}`
              } else {
                  text_with_discount_for_promo = `${this.$t('for %1 month, then <br/>%2/month').replace('%1', promo_price_text).replace('%2', price_month_formatted)}`
              }
      span_promo_space = promo_price_text && this.currentProduct.plan.plan_promo_subscription_duration.length > 0 && this.dateTimeForPlansPromo ? '<span class="u-flex u-flex-column u-marg-t-md--ml"></span>' : '';
      span_promo = promo_price_text && this.currentProduct.plan.plan_promo_subscription_duration.length > 0 && this.dateTimeForPlansPromo ? text_with_discount_for_promo : '';

        return `
          <div class="u-flex u-flex-justify-between">
            <div class="u-flex u-flex-column">
              <span class="u-white">${this.currentProduct.plan.name}</span>
              ${span_promo_space}
              ${liveboxAdvantageSpan}
              <span class="u-white u-marg-t-xxs">${ this.$t('Instalment') }</span>

            </div>
            <div class="u-flex u-flex-column u-marg-l-md u-right">
                <span class="u-orange">${monthly_price_formatted}/${this.$t('month')}
                <sub class="u-block c-pricing__muted-text u-weight-normal u-grey-600 u-marg-b-xxxs u-line-height-normal"> ${span_promo} </sub>
                </span>
                 ${liveboxDiscountSpan}
               <span class="u-orange u-marg-t-xxs">${instalmentAmount}</span>
            </div>
          </div>
        `
          }
      }  else {
        return `
          <div class="u-flex u-flex-justify-between">
            <div class="u-flex u-flex-column">
              <span class="u-white">${this.currentProduct.plan.name}</span>
              ${liveboxAdvantageSpan}
              <span class="u-white u-marg-t-xxs">${this.$t('Instalment')}</span>
            </div>
            <div class="u-flex u-flex-column u-marg-l-md u-right">
              <span class="u-orange">${monthly_price_formatted}/${this.$t('month')}</span>
              ${liveboxDiscountSpan}
              <span class="u-orange u-marg-t-xxs">${locale === 'en' ? `${currency}0` : `0${currency}`}/${this.$t('month')}</span>
            </div>
          </div>
        `
      }
    }
  },
  data () {
    return {
      popOverPlacement: 'bottom',
      popOverInfosID: '',
      currentPopeOver: ''
    }
  },
  mounted () {

    // Make sure all the popover are initialized
    $('[data-toggle="popover"]').popover()

    this.popOverPlacement = Helpers.isMobile() ? 'top' : 'bottom'

    document.addEventListener('scroll', function() {
      $('#popover-monthly').popover('hide');
      this.currentPopeOver = ''
    })

    this.popOverInfosID = Helpers.isMobile() ? '#popover-infos-mobile' : '#popover-infos-desktop'

    document.addEventListener('scroll', () => {
      $(this.popOverInfosID).popover('hide');
      this.currentPopeOver = ''
    })

    const devicePlanSkuFromUrl = Helpers.getParamValue('fromPlan');

    /**
     * Hide popover when the user click anywhere on the page
     * except when the user click on any node contains in plan slider
     */
    $('body').on('click', function (e) {
      // If there is a plan in the url and no slider we don't check the slider
      if (devicePlanSkuFromUrl && document.querySelector('.c-plan-slider .flickity-viewport') === null) {
        if (
          $(e.target).data('toggle') !== 'popover' &&
          $(e.target).parents('[data-toggle="popover"]').length === 0 &&
          $(e.target).parents('.popover.in').length === 0
        ) {
          $('[data-toggle="popover"]').popover('hide');
        }
      } else {
        if( $(e.target).data('toggle') !== 'popover' &&
          $(e.target).parents('[data-toggle="popover"]').length === 0 &&
          $(e.target).parents('.popover.in').length === 0 &&
          !document.querySelector('.c-plan-slider')){
          $('[data-toggle="popover"]').popover('hide');
          return
        }
        if (
          $(e.target).data('toggle') !== 'popover' &&
          $(e.target).parents('[data-toggle="popover"]').length === 0 &&
          $(e.target).parents('.popover.in').length === 0 &&
          document.querySelector('.c-plan-slider .flickity-viewport').contains(e.target) === false
        ) {
          $('[data-toggle="popover"]').popover('hide');
        }
      }
    })

    const self = this
    /**
     * Update Anowave GTM plugin ( update the dataLayer ) when the user add a product to his cart.
     */
    AEC.Storage.set('VariantFromDevice', '')
    AEC.EventDispatcher.on('ec.add.data', function(data){
      if (self.currentProduct.plan.sku !== '' && data.ecommerce.add.products[0].additional_product !== 'Yes') {
        data.ecommerce.add.products[0].additional_product = 'Yes'
        data.ecommerce.add.products[0].additional_product_brand = 'Orange'
        data.ecommerce.add.products[0].additional_product_category = 'Plan'
        data.ecommerce.add.products[0].additional_product_name = self.currentProduct.plan.name
        data.ecommerce.add.products[0].additional_product_price = self.currentProduct.plan.monthly_price
        data.ecommerce.add.products[0].additional_product_variant = self.currentProduct.plan.sku
        // Set the variant in localstorage to use it in the configurator page
        AEC.Storage.set('VariantFromDevice', data.ecommerce.add.products[0].variant)
        return data
      }
    })
  },
  watch: {
    'currentProduct.plan.name': function (newName, oldName) {
      if (newName !== oldName) {
        this.$nextTick(() => {
          const selector = '.' + this.currentPopeOver
          if (document && selector.length > 2 && document.querySelector(selector)) {
            document.querySelector(selector).innerHTML = this.popOverBodyContent
          }
        })
      }
    }
  },
  methods: {
    ...mapMutations({
        updateButtonState: 'UPDATE_ADD_TO_CART_BUTTON_STATE'
    }),
    templateBasePopOver (className) {
      return `
        <div class="${ className }">
          ${ this.popOverBodyContent }
        </div>`
    },
    formatPrice(price) {
      if (isNaN(parseInt(price))) {
          return price
      }

      price = parseFloat(price);

      if (price % 1 === 0) {
          price = parseInt(price, 10);
      } else {
          price = price.toFixed(2);
      }

      const formattedPrice = this.productInformations.locale === 'en'
          ? price
          : price.toString().replace('.', ',');

      return this.productInformations.locale === 'en'
          ? `€${formattedPrice}`
          : `${formattedPrice}€`;
    },
    sendDataToMagento () {
      /**
       * Make sure capacity is clicked before validate the form
       */
      const capacity = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.currentProduct.capacity.id}`)
      const isCapacityChecked = capacity.className.includes('selected')

      if (capacity && !capacity.disabled && !isCapacityChecked) capacity.click()

      // if this.currentProduct.plan is not empty it means the user
      // selected a plan from the carousel so we use the user selection
      // if not we take the first plan by default
      if (
        this.currentProduct.plan &&
        this.currentProduct.plan.option_value &&
        this.currentProduct.plan.option_id
      ) {
        const plan = document.querySelector(`[name="options[${this.currentProduct.plan.option_id}]"][value="${this.currentProduct.plan.option_value}"]`)

        if (plan) {
          plan.checked = true
        }
      } else {
        const plan = document.querySelector(`[name="options[${this.currentProduct.availablePlans[0].option_id}]"][value="${this.currentProduct.availablePlans[0].option_value}"]`)

        if (plan) {
          plan.checked = true
        }
      }

      const addToCartButton = document.querySelector("#product-addtocart-button")

      if (!this.addToCartButtonState.disabled) {
        addToCartButton.click()
      }

      // Disabled button to avoid user to spam the button
      // and signal the user we add the product to the cart
      this.updateButtonState('discretDisabledLoading')

      $(document).on('customer-data-reload', (event, data) => {
        // if data includes cart it means the cart is updated
        // so we redirect to the checkout
        if (data.includes('cart')) {
          window.location.href = this.productInformations.cartUrl
        }
      })
    },
    addToCart(el) {
      el.preventDefault();

      if (this.addToCartButtonState.disabled) return

      if (this.currentProduct.formReady) {

          if (this.currentProduct.plan.instalment_duration == 0 && this.currentProduct.plan.instalment_amount == 0 && this.currentProduct.plan.device_plan_engagement_duration == 0) {
                  document.querySelector("input[id='no_instalments']").value = 1;
          }
          const addToCartFromModal = document.querySelector('#modal-addtocart .js-modal-add')
          const addToCartRegularClass = 'gtm-section-regular-add-to-cart';

        /**
         * If there is a plan sku it means the user had choosed the phone with a plan
         * so we display the modal and wait for the click
         *
         * If the user choose the phone only we don't display the modal
         */
        if (this.packageWithPhone && this.currentProduct.device_plan_sku && this.currentProduct.device_plan_sku.length > 0) {
            if (el.target.parentNode.classList.contains(addToCartRegularClass)) {
                this.sendDataToMagento()
                console.log('1');
            } else {
                addToCartFromModal.addEventListener('click', () => {
                    this.sendDataToMagento()
                })
                console.log('2');
            }
        } else {
          console.log('33333');
          this.sendDataToMagento()
          console.log('222');
        }
      }
    },
      showLiveboxAdvantage() {
          if (!this.currentProduct.plan.subscription_convergent_discount || this.currentProduct.plan.subscription_convergent_discount.length === 0) {
              return false;
          }

        let queryParam = new URLSearchParams(window.location.search);
        if (+queryParam.get('livebox_prices')) {
          return true;
        } else if (queryParam.get('livebox_prices') == 0) {
            return false;
        }

        return localStorage.getItem('is_enable_livebox_for_plan') == '1';
      },
  }
}
</script>
